module.exports = __webpack_public_path__ + "static/media/1462825746410.bf438571.jpg";